import { render, staticRenderFns } from "./AdminProductAvailability.vue?vue&type=template&id=205bd7cb&"
import script from "./AdminProductAvailability.vue?vue&type=script&lang=js&"
export * from "./AdminProductAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports